import React from "react";
import { GooglePlayRedirectUrl } from "../../utils/constants";
import { handleDownloadAppClickedEvent } from "../../utils/helperEventFunctions";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

const PlayStoreLogo = ({ className, desktopStatus, mobileStatus }) => {
  const router = useRouter();
  const firebaseUID = useSelector((state) => state.currentUser.firebaseUID);
  return (
    <div>
      <a
        href={GooglePlayRedirectUrl}
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          handleDownloadAppClickedEvent({
            firebaseUID,
            desktopStatus,
            mobileStatus,
            sourceScreen: router.pathname,
          });
        }}
      >
        <img
          src="/assets/GooglePlay.webp"
          alt="GooglePlay"
          className={className || ""}
        />
      </a>
    </div>
  );
};

export default PlayStoreLogo;
